module.exports = __webpack_public_path__ + "media/customizations/rendezvous/logo-new-5c15e5495ba38fefb2f952d4ae93b7e7.png";